import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

interface BackButtonProps {
  /** Where to send the user if there's no browser history to go back to. Defaults to "/". */
  fallbackPath?: string;
  /** Button text. Defaults to "Go Back". */
  label?: string;
  /** Override the button's classes entirely if you need a different look on a given page. */
  className?: string;
}

/**
 * Generic "go back" button.
 *
 * Goes back one step in browser history if there is any, otherwise
 * navigates to `fallbackPath`. Safe to drop into any page - it owns its
 * own useNavigate() call, so it doesn't need anything passed down from
 * a parent.
 *
 * Usage:
 *   import BackButton from "../../components/BackButton"; // adjust path
 *   ...
 *   <BackButton />
 *   <BackButton fallbackPath="/dashboard" />
 *   <BackButton label="Back to List" />
 */
const BackButton: React.FC<BackButtonProps> = ({
  fallbackPath = "/",
  label = "Go Back",
  className = "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center",
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  };

  return (
    <button type="button" onClick={handleBack} className={className}>
      {/* <ArrowLeftIcon className="h-4 w-4 mr-2" /> */}
      {label}
    </button>
  );
};

export default BackButton;
